import React from 'react';

const Separator = () => {
  return (
    <div
      style={{
        borderTop: '1px solid #c6c6c6',
        height: '0.75rem',
        backgroundColor: '#f3f3f3',
        margin: '0.75rem 0',
      }}
    ></div>
  );
};

export default Separator;
